
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface BankingSectionProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
}

export function BankingSection({ register, errors }: BankingSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Bankverbindung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label>Bank Name</Label>
          <Input 
            {...register("bank_name")} 
            placeholder="UBS, Credit Suisse, etc."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>IBAN</Label>
            <Input 
              {...register("iban", {
                pattern: {
                  value: /^CH\d{2}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{1}$/,
                  message: "Ungültiges IBAN Format für die Schweiz"
                }
              })} 
              placeholder="CH93 0076 2011 6238 5295 7"
            />
            {errors.iban && <p className="text-red-500 text-sm">{errors.iban.message as string}</p>}
          </div>
          
          <div className="space-y-2">
            <Label>Clearing Nummer</Label>
            <Input 
              {...register("bank_clearing_number")} 
              placeholder="Clearing-Nr."
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
